export default __webpack_public_path__ + "static/media/iconCamera.2ac9ffaf.svg";